'use strict';

var $fullOverlays = $('.full-overlay');

var handleOverlayClose = function handleOverlayClose(evt) {
    evt.preventDefault();
    $fullOverlays.removeClass('open');
};

var handleEscapeKey = function handleEscapeKey(evt) {
    $fullOverlays.removeClass('open');
};

module.exports = function() {
    $(".full-overlay__close").on('click', handleOverlayClose);

    $(document).keyup(function(evt) {
        if (evt.keyCode == 27) {
            handleEscapeKey(evt);
        }
    });
};



// WEBPACK FOOTER //
// ./resources/js/components/overlay.js